
export const notEmptyString = value => typeof value === 'string' && value !== '';
